var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"slide-image-captcha"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('captcha',{ref:"dialogopen",attrs:{"l":42,"r":10,"w":_vm.catcha.w,"h":_vm.catcha.h,"blocky":_vm.catcha.blocky,"imgurl":_vm.catcha.imgurl,"miniimgurl":_vm.catcha.miniimgurl,"slider-text":_vm.catcha.text},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh,"close":_vm.onClose}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6337fa30","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/captcha2/slideImageCaptcha.vue
// module id = 385
// module chunks = 0